import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { SelectedPanelEnum } from '@app/core/enums/selected-panel.enum';
import { MyZoneRoutesEnum } from '@app/my-zone/my-zone-routes.enum';
import { AppRoutesEnum } from '@app/routes/app-routes.enum';
import { PolicyProductIdEnum } from 'outshared-lib';

@Component({
    selector: 'ins-insurance-list-link',
    templateUrl: 'insurance-list-link.component.html',
})
export class InsuranceListLinkComponent {
    @Input() public productSequenceNumber!: number;
    @Input() public productId!: PolicyProductIdEnum;
    @Input() public openPanel!: SelectedPanelEnum;
    @Input() public selectedPanel!: SelectedPanelEnum;
    @Input() public title?: string;

    public selectedPanelEnum = SelectedPanelEnum;

    constructor(private router: Router) {}

    public onNavigate(): void {
        const queryParams = {
            productSequenceNumber: this.productSequenceNumber,
            productId: this.productId,
            panel: this.openPanel,
        };

        this.router.navigate(['/', AppRoutesEnum.MyZone, MyZoneRoutesEnum.MyInsurances], { queryParams });
    }
}
